import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import Hero from './components/Hero';
import TodayRecommend from './components/TodayRecommend';
import HotCategories from './components/HotCategories';
import FeaturedCollection from './components/FeaturedCollection';
import FAQ from './components/FAQ';
import { siteInfo } from '@/mocks/articles';

export default function Home() {
  const webSiteLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: 'https://powen-tuijian.com',
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://powen-tuijian.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: 'https://powen-tuijian.com',
    description: siteInfo.description,
    foundingDate: siteInfo.foundedYear,
    contactPoint: {
      '@type': 'ContactPoint',
      email: siteInfo.email,
      contactType: 'customer service',
    },
  };

  return (
    <>
      <SEOHead
        title="po文推荐 - 精选高质量内容一站汇聚"
        description={siteInfo.description}
        canonicalUrl="https://powen-tuijian.com"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationLd) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <Hero />
          <TodayRecommend />
          <HotCategories />
          <FeaturedCollection />
          <FAQ />
        </main>
        <Footer />
      </div>
    </>
  );
}